<script setup lang="ts">
import { useFormValidation } from '../../../../composables/useFormValidation'
import { required } from '../../../../utils/validation'
import TextInput from '../../../../components/ui/form/TextInput.vue'
import CheckInput from '../../../../components/ui/form/CheckInput.vue'
import { api } from '../../../../api/Api'
import Toast from '../../../../services/Toast'
import { Permission } from '../../../../types/auth'
import SearchSelect from '../../../../components/ui/form/SearchSelect.vue'
import { ref, onMounted } from 'vue'
import ModalFormTemplate from '../../../../components/ui/Templates/ModalFormTemplate.vue'

const props = defineProps<{
  data?: any | null
  mode: 'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'
  title: string | null
  endPoint: string,
  permissions?: Permission[],
  listCreateName?: string
}>()

const emit = defineEmits<{
  (e: 'save', data: any): void
  (e: 'close'): void
}>()

const { fields, formData, setFieldRules, validateForm, resetForm, setFormData } = useFormValidation({
  code: props.data?.code || '',
  name: props.data?.name || props.listCreateName || '',
  currencys_id: props.data?.currencys_id || '',
  account_types_id: props.data?.account_types_id || '',
  chart_of_accounts_id: props.data?.chart_of_accounts_id || '',
  allow_reconciliation: props.data?.allow_reconciliation || false,
  allow_depreciation: props.data?.allow_depreciation || false,
  active: props.data?.active || true,
  uid: props.data?.uid || '',
})

setFieldRules('code', [required('Code is required')])
setFieldRules('name', [required('Account Name is required')])
setFieldRules('account_types_id', [required('Account Type is required')])
setFieldRules('currencys_id', [required('Currency is required')])


const handleSubmit = async (close: boolean, newRecord: boolean) => {
  if (validateForm()) {
    const action = formData.value.uid != '' ? 'update' : 'create'
    const response = await api.post((props.endPoint.slice(-1) == '/' ? props.endPoint : props.endPoint + '/') + action, formData.value)
    if (response.success == true) {
      Toast.show('saved successfully')
      emit('save', response.data)
      if (close) {
        emit('close')
      } else if (newRecord) {
        resetForm()
      } else {
        setFormData(response.data)
      }
    }
  }
}

const isReadOnly = ref(true);
onMounted(() => {
  isReadOnly.value = props.mode == 'view'
  if (props.mode == 'create') {
      resetForm()
    } else if (props.data) {
      setFormData(props.data)
    }
})

</script>
<template>
  <ModalFormTemplate :data="data" :mode="mode" :title="title" :endPoint="endPoint" :perm="permissions"
    :listCreateName="listCreateName" :tabList="[]" :formData="formData" @save="handleSubmit"
    @close="$emit('close')">
    <template #form>
      <div class="grid md:grid-cols-2 gap-6">
        <TextInput v-model="fields.code.value" label="Code" placeholder="Enter Code" :readonly="isReadOnly"
          :error="fields.code.touched ? fields.code.error : null" @blur="fields.code.touched = true" />

        <TextInput v-model="fields.name.value" label="Name" placeholder="Enter Name" :readonly="isReadOnly"
          :error="fields.name.touched ? fields.name.error : null" @blur="fields.name.touched = true" />

        <SearchSelect v-model="fields.account_types_id.value" end-point="finance/accounting/account-types"
          label="Account Type" :readonly="isReadOnly"
          :error="fields.account_types_id.touched ? fields.account_types_id.error : null"
          @blur="fields.account_types_id.touched = true" />

        <SearchSelect v-model="fields.chart_of_accounts_id.value" label="Parent Account" :readonly="isReadOnly"
          end-point="finance/accounting/chart-of-accounts"
          :error="fields.chart_of_accounts_id.touched ? fields.chart_of_accounts_id.error : null"
          @blur="fields.chart_of_accounts_id.touched = true" />

         <SearchSelect v-model="fields.currencys_id.value" label="Currency" :readonly="isReadOnly"
          end-point="finance/master-data/currency"
          :error="fields.currencys_id.touched ? fields.currencys_id.error : null"
          @blur="fields.currencys_id.touched = true" />

      </div>
      <div class="grid md:grid-cols-3 gap-6">

        <CheckInput v-model="fields.allow_reconciliation.value" :readonly="isReadOnly" label="Allow Reconciliation"
          :error="fields.allow_reconciliation.touched ? fields.allow_reconciliation.error : null"
          @blur="fields.allow_reconciliation.touched = true" />

        <CheckInput v-model="fields.allow_depreciation.value" :readonly="isReadOnly" label="Allow Depreciation"
          :error="fields.allow_depreciation.touched ? fields.allow_depreciation.error : null"
          @blur="fields.allow_depreciation.touched = true" />

        <CheckInput v-model="fields.active.value" :readonly="isReadOnly" label="Active"
          :error="fields.active.touched ? fields.active.error : null" @blur="fields.active.touched = true" />

      </div>
    </template>
  </ModalFormTemplate>
</template>